// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/1792058191362/css/" + chunkId + ".chunk.css";
};